import { CULTURAL_COMPASS_PROGRAM_DESC, RESUME_BOOST_PROGRAM_DESC } from "./constants";

const translations = {
    en: {
        programs: "Programs",
        getInvolved: "Get Involved",
        blogs: "Blogs",
        podcasts: "Podcast",
        about: "About",
        resources: "Resources",
        contact: "Contact Us",
        home: "Home",
        careerDevelopment: "Career Development",
        mentorship: "Mentorship",
        networking: "Networking",
        learnMore: "Learn More",
        culturalCompass: "Cultural Compass",
        resumeBoost: "Resume Boost",
        mission: "Our mission is empowering the Mongolian American college students & young professionals’ success by fostering a strong sense of community providing tailored resources for personal and professional growth, and cultivating an environment where individuals can connect, learn, and thrive together.",
        missionAndImpact: "Mission & Impact",
        whatWeOffer: "What We Offer",
        donate: "Donate",
        events: "Events",
        eventsDesc: "Help us with organizing events...",
        volunteer: "Volunteer",
        internships: "Internships",
        connectWithUs: "Connect with us",
        newsletterPlaceholder: "Enter your email to receive our newsletters!",
        subscribe: "Subscribe",
        ourStory: "Our story",
        ourTeam: "Our Team",
        footerMission: "Empowering Mongolian American college students and young professionals to connect, learn, and thrive together.",
        time: "Time",
        event: "Event",
        location: "Location",
        contactDesc: "Have questions about our programs or Connect MNG in general? Please submit the form below and we'll be in touch shortly!",
        yourName: "Your name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
        getInTouch: "Get in touch",
        firstName: "First name",
        lastName: "Last name",
        emailAddress: "email address",
        emailSubject: "email subject",
        contactUs: "contact us",
        contactUsTitle: "Contact Us",
        contactUsDesc: "Have questions about our programs or Connect MNG in general? Please submit the form below and we'll be in touch shortly!",
        yourNameTitle: "YOUR NAME",
        firstNamePlaceholder: "First name",
        lastNamePlaceholder: "Last name",
        emailLabel: "EMAIL",
        emailPlaceholder: "Email address",
        subjectLabel: "SUBJECT",
        subjectPlaceholder: "Email subject",
        messageLabel: "MESSAGE",
        messagePlaceholder: "Your message",
        invalidEmail: "Invalid email",
        invalidEmailMessage: "Please enter a valid email",
        fillRequiredFields: "Required fields missing",
        pleaseFillAllFields: "Please fill out all required fields",
        emailSentSuccess: "Email sent successfully",
        weWillGetInTouch: "We will get in touch with you shortly!",
        emailSentError: "Failed to send email",
        pleaseTryAgain: "Please try again later",
        ourProgramsTitle: "Our Programs",
        ourProgramsDesc: "At Connect MNG, we’re here to support Mongolian students and young professionals as they take the next step in their careers. Through resume reviews and monthly workshops on essential career skills, we provide practical guidance to help you grow with confidence.",
        workshopDesc: CULTURAL_COMPASS_PROGRAM_DESC,
        resumeBoostDesc: RESUME_BOOST_PROGRAM_DESC,
        fundraising: "Fundraising",
        fundraisingDesc: "Help us with fundraising...",
        website: "Website",
        volunteerDesc: "Connect MNG offers various ways for passionate individuals to contribute and make a difference in our community. Whether you're looking to lend a helping hand, raise awareness, or offer your expertise, there's a place for you here. Explore the following avenues to get involved:",
        becomeVolunteer: "Become a volunteer!",
        getStarted: "Get Started",
        aboutUsTitle: "About Us",
        ourValuesTitle: "Our Values",
        ourStoryHeading1: "Hello and a warm, heartfelt welcome to",
        ourStoryHeading2: "Connect MNG!",
        ourStorySub1: "A Community Rooted in Connection",
        ourStoryText1: "Connect MNG is a cozy corner where Mongolian American college students and young professionals can unite and support each other's growth through resources, programs, and events.",
        ourStorySub2: "Our Passionate Team",
        ourStoryText2: "At Connect MNG, our strength lies in our diverse and passionate team of Mongolians in Seattle. Each member brings a unique set of skills, experiences, and a deep commitment to empowering the Mongolian American community. We come from different backgrounds, united by our dedication to supporting our community in America.",
        ourStorySub3: "We are committed.",
        ourStoryText3: "We have board members, chair members, and interns working hard to build Connect MNG from the ground up—whether by developing our website, planning programs, writing resourceful blogs, or creating a space where Mongolians can connect. Our interns dedicate countless hours on weekdays and weekends, before and after school, coding our website and making it the central hub for resources. For the past two years, our chair members and board members have commuted every Friday after work to meet in person, collaborating on the website, developing programs and projects, and planning community events.",
        ourStorySub4: "Our Shared Mission",
        ourStoryText4a: "We created Connect MNG because each of us once faced these struggles alone—the search for connection and the desire to thrive personally and professionally in a foreign space so full of growth and opportunities.",
        ourStoryText4b: "We don't want the next generation of Mongolian college students and young professionals to go through this journey alone. We don't want them to feel the stress and pressure of figuring everything out by themselves. Instead, we want them to feel supported, connected, and empowered to thrive.",
        ourStorySub5: "Navigating Career Development Together",
        ourStoryText5a: "Embarking on your career journey? Feeling a bit lost? Connect MNG is here to guide you.",
        ourStoryText5b: "Whether you're a college student applying for internships or a young professional navigating career development, we're here to help. We will help you in building and tailoring your resume to increase your chances in the professional world. We'll help you navigate networking and interviews. But most importantly, we'll help you find a community and friends. You are not alone.",
        ourStorySub6: "In Closing - Let's Thrive Together",
        ourStoryText6a: "Connect MNG isn't just a nonprofit—it's a community of friends, each with a unique story to tell. As Mongolians in America, let's support each other!",
        ourStoryText6b: "Join us, and let's connect!",
        ourStorySignOff: "Anuujin Ider\nPresident, Connect MNG",
        internshipsDescription: "At Connect MNG, we offer dynamic internship opportunities for students and young professionals looking to gain real-world experience while contributing to the Mongolian community. Our internships are designed to provide hands-on learning, mentorship, and professional development in a collaborative and impactful environment.",
        internshipsWhyJoin: "Why Join?",
        internshipsWhyJoinBody: "Gain Practical Experience in web development, project management, marketing, event coordination, and more. Enhance Your Resume with meaningful, community-driven work. Expand Your Network by connecting with professionals and leaders in the Mongolian community. Make a Difference while developing valuable skills for your future career.",
        internshipsAreas: "Internship Areas:",
        internshipsList1: "Web Development",
        internshipsList2: "Marketing & Communications - Help us promote initiatives and engage the community.",
        internshipsList3: "Event/Workshop Planning - Assist in organizing impactful events and gatherings.",
        internshipsList4: "Fundraising & Outreach - Support efforts to sustain and grow our programs.",
        internshipsList5: "Project Management - Work on meaningful initiatives that drive community impact.",
        internshipsHowToJoin: "How to Join:",
        internshipsStep1: "1. Fill out our application - Let us know about your background, skills, and interests.",
        internshipsStep2: "2. Interview with our team - If selected, you'll have a short conversation to ensure a great fit.",
        internshipsStep3: "3. Once accepted, you will receive an email from our team! Apply Today!",
        volunteer: "Volunteer",
        volunteerDesc: "Connect MNG offers meaningful ways for passionate individuals to contribute and make a difference in our community. Joining us as a volunteer is a simple and rewarding process! Whether you're looking to lend a helping hand, raise awareness, or share your expertise, we welcome passionate individuals eager to give back to the community.",
        whyJoinTitle: "Why Join?",
        whyJoinList1: "Gain hands-on experience in project management, marketing, event planning, and more.",
        whyJoinList2: "Build your resume with impactful, community-driven work.",
        whyJoinList3: "Expand your network and connect with inspiring Mongolian professionals.",
        whyJoinList4: "Make a real difference while learning and growing.",
        exploreTitle: "Explore the following avenues to get involved:",
        fundraising: "Fundraising",
        events: "Events",
        howToJoinTitle: "How to Join:",
        howToJoinDesc: "Click our application link and fill it out! Let us know your interests and skills, and we will match you with the right opportunity. Once accepted, you will receive an email from our team!",
        readMore: "Read More",

        // Donation page translations
        empowerYoungMongolians: "Empower young Mongolian professionals",
        donateConnectMNG: "Donate to Connect MNG",
        onetimeDonation: "Make a one-time gift",
        customAmount: "Custom Amount",

        // support popup translations
        supportConnect: "Support Connect MNG!",
        yourContributionText: "Your contribution will help to inspire, educate, and equip Mongolian students with skills to navigate through today's world and give back to the community.",

        // our story page translations
        ourStory: "Our Story",
        ourStoryText: "Short paragraph about our story",

        // our team page translations
        aboutUs: "About Us",
        aboutUsDesc: "Connect MNG is a nonprofit organization dedicated to empowering Mongolians in Washington state by fostering career development, professional growth, and a strong sense of community. Our team comes from diverse backgrounds, bringing together a wealth of experience and knowledge to support and uplift our members. We provide resources, mentorship, and networking opportunities to help individuals advance in their careers while creating a supportive environment where members can learn from one another. Through collaboration and shared experiences, we strive to build a stronger, more connected community.",
        ourValues: "Our Values",
        ourValuesDesc: "At Connect MNG, we believe in community, empowerment, and growth. We are dedicated to fostering an inclusive space where Mongolian-American college students and young professionals can connect, learn, and thrive. By promoting cultural identity, career development, and leadership, we aim to equip individuals with the tools and opportunities they need to succeed—both personally and professionally.",
        meetBoard: "Meet the Board",
        meetInterns: "Meet the Interns",

        // footer translation
        engage: "ENGAGE",
        explore: "EXPLORE",
        termsOfUse: "Terms of Use",
        privacyPolicy: "Privacy Policy",

        // Event page translations
        Date: "Monday 29th January 2024",
        Calendar: "Calendar",
        Time: "Time",
        Event: "Event",
        Location: "Location",
        date: "Monday 29th January 2024",
        time: "3pm",
        time1: "4pm",

        // Happy hour event translations
        date_time: "📅 Monday 29th January 2024 | 🕒 4:00 PM",
        happy_location: "📍 Location: Bangrak",
        happy_desc1: "Join us for a **fun and relaxing Happy Hour** at Bangrak! 🎉",
        happy_desc2: "🥂 Meet new people, network, and unwind with refreshing drinks and great conversations.",
        happy_desc3: "📢 This event is open to all members. Bring your friends!",
        h_back_to_events: "⬅ Back to Events",

        // Resume help event translations
        resume_date_time: "📅 Monday 29th January 2024 | 🕒 3:00 PM",
        resume_location: "📍 Location: Capital One Cafe",
        resume_desc1: "Join us for an interactive **Resume Help Workshop** where industry experts will provide tips on crafting an impressive resume that stands out!",
        resume_desc2: "📝 Learn best practices, formatting tips, and how to highlight your skills effectively.",
        resume_desc3: "🎯 Ideal for job seekers and students looking to refine their resumes.",
        r_back_to_events: "⬅ Back to Events",

        // Resume building event translations
        resume_building_date_time: "📅 Saturday 27th September 2025 | 🕒 12:00 PM - 2:00 PM",
        resume_building_location: "📍 Location: Capital One Cafe SLU",
        resume_building_desc1: "Join us for an interactive Resume Help Workshop where industry experts will provide tips on crafting an impressive resume that stands out! Limited spots available!",
        resume_building_desc2: "📝 Learn best practices, formatting tips, and how to highlight your skills effectively.",
        resume_building_desc3: "🎯Ideal for job seekers and students looking to refine their resumes.",
        rb_back_to_events: "⬅ Back to Events",

    },
    mn: {
        programs: "Хөтөлбөрүүд",
        getInvolved: "Таны Оролцоо",
        blogs: "Блог",
        podcasts: "Подкаст",
        about: "Бидний Тухай",
        resources: "Нэмэлт Мэдээлэл",
        contact: "Бидэнтэй Холбогдох",
        home: "Нүүр",
        careerDevelopment: "Карьер Хөгжил",
        mentorship: "Мэнторшип",
        networking: "Нетворк",
        learnMore: "Дэлгэрэнгүй",
        culturalCompass: "Соёлын чиглүүлэгч",
        resumeBoost: "CV Сайжруулалт",
        mission: "Америк дахь Монгол оюутан залуус болон залуу мэргэжилтнүүдийг хувийн болон мэргэжлийн хөгжилд зориулсан мэдээллийн нөөцөөр хангаж, хувь хүмүүс хоорондоо холбогдож, суралцаж, хамтдаа хөгжих боломжтой орчныг бүрдүүлэх.",
        missionAndImpact: "Зорилго & Нөлөө",
        whatWeOffer: "Бидний санал болгох",
        donate: "Хандив",
        events: "Үйл ажиллагаа",
        eventsDesc: "Үйл ажиллагаа зохион байгуулахад\nбидэнд туслах...",
        volunteer: "Сайн Дурын Ажил",
        internships: 'Дадлага',
        newsletterPlaceholder: "Манай мэдээллийг хүлээн авах имэйлээ оруулна уу.",
        subscribe: "Бүртгүүлэх",
        ourStory: "Бидний Түүх",
        ourTeam: "Манай Баг",
        footerMission: "Монгол Америкийн коллежийн оюутнууд болон залуу мэргэжилтнүүдийг холбогдож, суралцаж, хамтдаа хөгжихөд нь дэмжих.",
        time: "Цаг",
        event: "Эвент",
        location: "Хаяг",
        contactDesc: "Биднээс асуух асуулт байгаа бол доорх формыг бөглөнө үү. Бид удахгүй хариу өгөх болно. Баярлалаа",
        yourName: "Таны Нэр",
        email: "Имэйл",
        phone: "Утас",
        subject: "Гарчиг",
        message: "Мессэж",
        getInTouch: "Бидэнтэй Холбогдох",
        firstName: "Нэр",
        getInTouch: "Бидэнтэй Холбогдох",
        firstName: "Нэр",
        lastName: "Овог",
        emailAddress: "Имэйл хаяг",
        emailSubject: "Имэйл гарчиг",
        contactUs: "Холбогдох",
        contactUsTitle: "Холбогдох",
        contactUsDesc: "Манай хөтөлбөрүүд эсвэл Connect MNG-ийн талаар асуух зүйл байвал доорх маягтыг бөглөн бидэнтэй холбогдоорой.",
        yourNameTitle: "ТАНЫ НЭР",
        firstNamePlaceholder: "Нэр",
        lastNamePlaceholder: "Овог",
        emailLabel: "ИМЭЙЛ",
        emailPlaceholder: "Имэйл хаяг",
        subjectLabel: "ГАРЧИГ",
        subjectPlaceholder: "Имэйл гарчиг",
        messageLabel: "МЭССЭЖ",
        messagePlaceholder: "Таны мэссеж",
        invalidEmail: "Имэйл хаяг буруу байна",
        invalidEmailMessage: "Зөв имэйл хаяг оруулна уу",
        fillRequiredFields: "Шаардлагатай мэдээлэл дутуу байна",
        pleaseFillAllFields: "Бүх шаардлагатай мэдээллийг бөглөнө үү",
        emailSentSuccess: "Имэйл амжилттай илгээгдлээ",
        weWillGetInTouch: "Бид тун удахгүй холбогдох болно!",
        emailSentError: "Имэйл илгээхэд алдаа гарлаа",
        pleaseTryAgain: "Дахин оролдоно уу",
        ourProgramsTitle: "Манай хөтөлбөрүүд",
        ourProgramsDesc: "Бид танд мэргэжллийн үндсэн чадварууд дээрх анкет бөглөлт болон сар бүрийн сэминараар өөртөө итгэлтэйгээр өсөх үр ашигтай зөвлөгөөг үзүүлнэ.",
        workshopDesc: "Cultural Compass хөтөлбөр нь Америкт сурч боловсорч байгаа Монгол болон Монгол Америк оюутан залууст зориулсан хөтөлбөр юм. Энэхүү хөтөлбөрөөр оюутан залуус хамтдаа харилцан бие биеэ дэмжин тусалж, соёлын ялгааг даван туулах орчныг бүрдүүлэх нь бидний зорилго юм.",
        resumeBoostDesc: "Resume Boost хөтөлбөр нь хоёр долоо хоногийн ажлын салбарт шинээр гарч буй залууст болон оюутан сурагчдад зориулсан хөтөлбөр юм. Оролцогчид өнөөгийн өрсөлдөөнт хөдөлмөрийн зах зээлд амжилтад хүрэхийн тулд ажлын анкетуудаа оновчтой болгож тухайн салбарын мэргэжилтнүүдээс зөвлөгөө болон санал хүсэлт авах боломжтой.",
        fundraising: "Хандив",
        fundraisingDesc: "Хандив босгоход бидэнд туслах...",
        website: "Вэб Хаяг",
        volunteerDesc: "Connect MNG-тэй хамтран ажиллах болон өөрийн оролцоогоороо Вашингтон мужид байгаа Монголчуудад зорилсан хөтөлбөрүүдийг дэмжих хүсэлтэй бол та дараах байдлаар өөрийн оролцоог нэмэх боломжтой юм:",
        becomeVolunteer: "САЙН ДУРЫН АЖИЛТАН БОЛОХ",
        getStarted: "Эхлэх",
        readMore: "Дэлгэрэнгүй",

        // Donation page translations
        empowerYoungMongolians: "Залуу Монгол мэргэжилтнүүдийг дэмжих",
        donateConnectMNG: "Connect MNG-д хандив өгөх",
        onetimeDonation: "Нэг удаагийн хандив өгөх",
        customAmount: "Тохируулсан Дүн",

        // support popup translations
        supportConnect: "Connect MNG-г дэмжих!",
        yourContributionText: "Таны оролцоо нь Монгол оюутнуудын сонирхол, сургалт, боловсролын ур чадварыг хөгжүүлэх, ур чадваруудыг эзэмших зорилготой болно.",


        // our story page translations
        ourStory: "Бидний түүх",
        ourStoryText: "Бидний түүхийн товч тайлбар",

        // our team page translations
        aboutUs: "Бидний тухай",
        aboutUsDesc: "Connect MNG is a nonprofit organization dedicated to empowering Mongolians in Washington state by fostering career development, professional growth, and a strong sense of community. Our team comes from diverse backgrounds, bringing together a wealth of experience and knowledge to support and uplift our members. We provide resources, mentorship, and networking opportunities to help individuals advance in their careers while creating a supportive environment where members can learn from one another. Through collaboration and shared experiences, we strive to build a stronger, more connected community.",
        ourValues: "Бидний Зорилго",
        ourValuesDesc: "At Connect MNG, we believe in community, empowerment, and growth. We are dedicated to fostering an inclusive space where Mongolian-American college students and young professionals can connect, learn, and thrive. By promoting cultural identity, career development, and leadership, we aim to equip individuals with the tools and opportunities they need to succeed—both personally and professionally.",
        meetBoard: "Багийн гишүүд",

        // footer translations
        connectWithUs: "Бидэнтэй Холбогдох",
        engage: "Таны Оролцоо",
        explore: "Зочлох",
        termsOfUse: "Ашиглалтын Нөхцөл",
        privacyPolicy: "Нууцлалын Баталгаа",



        // Event page translations
        Date: "1-р сарын 24, Даваа гариг, 2024",
        Calendar: "Календарь",
        Time: "цаг",
        Event: "үйл явдал",
        Location: "байршил",
        date: "1-р сарын 24, Даваа гариг, 2024",
        time: "15:00",
        time1: "16:00",

        // Happy hour event translations
        date_time: "📅 2024 оны 1 сарын 29, Даваа гараг | 🕒 16:00",
        happy_location: "📍 Байршил: Bangrak",
        happy_desc1: "Бидэнтэй нэгдэж **хөгжилтэй, тайвширсан Happy Hour**-д хамрагдаарай Bangrak! 🎉",
        happy_desc2: "🥂 Шинэ хүмүүстэй танилцаж, харилцаа холбоо тогтоож, сэтгэл сэргээсэн ундаа ууж, сайхан яриа өрнүүлээрэй.",
        happy_desc3: "📢 Энэхүү арга хэмжээнд бүх гишүүд оролцох боломжтой. Найзуудаа авчир!",
        h_back_to_events: "⬅ Үйл явдал руу буцах",

        // Resume help event translations
        resume_date_time: "📅 2024 оны 1 сарын 29 Даваа гараг | 🕒 15:00",
        resume_location: "📍 Байршил: Capital One Cafe",
        resume_desc1: "Салбарын мэргэжилтнүүд оролцдог интерактив **Resume Help Workshop**-д бидэнтэй нэгдээрэй гайхалтай анкет бүтээх талаар зөвлөгөө өгөх болно!",
        resume_desc2: "📝 Шилдэг туршлага, форматлах зөвлөмж, ур чадвараа хэрхэн үр дүнтэй онцлох талаар суралц.",
        resume_desc3: "🎯 Ажил хайгч болон анкетаа сайжруулах хүсэлтэй оюутнуудад тохиромжтой.",
        r_back_to_events: "⬅ Үйл явдал руу буцах",
    },
};

export default translations;
